import type { CartDiscountByKeyQuery } from '@az/middleware/src/__generated__/gql/graphql';

export default class GiftCartDiscount {
  id: string;
  key: string;
  name: string;
  description: string;
  validUntil: null | string;
  validFrom: null | string;
  isActive: boolean;
  cartPredicate: string;

  constructor(
    id: string,
    key: string,
    name: string,
    description: string,
    validUntil: null | string,
    validFrom: null | string,
    isActive: boolean,
    cartPredicate: string,
  ) {
    this.id = id;
    this.key = key;
    this.name = name;
    this.description = description;
    this.validUntil = validUntil;
    this.validFrom = validFrom;
    this.isActive = isActive;
    this.cartPredicate = cartPredicate;
  }

  isValid(): boolean {
    if (this.isActive) {
      const now = new Date();

      if (!this.validFrom && !this.validUntil) return true;
      else if (this.validFrom !== null && now < new Date(this.validFrom)) return false;
      else if (this.validUntil !== null && now > new Date(this.validUntil)) return false;

      return true;
    }

    return false;
  }

  getCeilingFromPredicate(): string {
    const regex = /totalPrice\s*>=\s*"(\d+\s*\w+)"/;
    const result = this.cartPredicate.match(regex);

    return result ? result[1] : null;
  }

  getCeilingPriceFromPredicate(): number {
    const ceiling = this.getCeilingFromPredicate();
    const regex = /(\d+)/;
    const result = ceiling.match(regex);

    return result ? parseInt(result[1], 10) : null;
  }

  getCeilingCurrencyFromPredicate(): string {
    const ceiling = this.getCeilingFromPredicate();
    const regex = /(\D+)/;
    const result = ceiling.match(regex);

    return result ? result[0].trim() : null;
  }

  getCountryCodesFromPredicate() {
    const regex = /country = "(\w+)"/g;
    let result;
    const countryCodes = [];

    while ((result = regex.exec(this.cartPredicate)) !== null) {
      countryCodes.push(result[1]);
    }

    return countryCodes;
  }

  static fromQueryResult(queryResult: CartDiscountByKeyQuery): GiftCartDiscount {
    const cartDiscount = queryResult.cartDiscount;

    return new GiftCartDiscount(
      cartDiscount.id,
      cartDiscount.key,
      cartDiscount.name,
      cartDiscount.description,
      cartDiscount.validUntil,
      cartDiscount.validFrom,
      cartDiscount.isActive,
      cartDiscount.cartPredicate,
    );
  }
}
